import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ProductsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${getPurpurSpacing('300')};

    ${purpurMedia('md')`
        grid-template-columns: repeat(auto-fill, minmax(19.875rem, 1fr));
    `}
`;

export const PaginationContainer = styled.div`
    margin-top: 0;

    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('400')};
    `}
`;
